import { application } from "./application"

import ContentLoader from '@stimulus-components/content-loader'
application.register('content-loader', ContentLoader)
